import { TypedUseSelectorHook, useSelector } from 'react-redux'

import { AppStore } from 'app/store'

export const useAppSelector: TypedUseSelectorHook<AppStore> = useSelector
